import { Injectable } from '@angular/core';
import type { WorkflowStep } from '../../shared/govco/workflow-steps.component';

@Injectable({ providedIn: 'root' })
export class WorkflowProgressService {
  private readonly completed = new Set<WorkflowStep>();

  complete(step: WorkflowStep): void { this.completed.add(step); }
  isCompleted(step: WorkflowStep): boolean { return this.completed.has(step); }
}
